// src/components/notes/CreateNoteGeneric.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext.js';
// import './CreateNoteGeneric.css';

export default function CreateNoteGeneric() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const token = sessionStorage.getItem('jwtToken');

  const [students, setStudents] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState('');
  const [noteDate, setNoteDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [content, setContent] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // fetch students for dropdown
  useEffect(() => {
    setLoading(true);
    axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/students/mystudents`,
      { headers: { Authorization: `Bearer ${token}`} }
    )
    .then(res => setStudents(res.data.data || res.data || []))
    .catch(err => console.error('Error fetching students', err))
    .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedStudentId) {
      setError('Selecteer eerst een leerling.');
      return;
    }
    setError(null);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/notes/add`,
        { studentId: selectedStudentId, noteDate, content },
        { headers: { Authorization: `Bearer ${token}`}}
      );
      navigate(-1);
    } catch (err) {
      console.error('Error creating note', err);
      setError('Er is een fout opgetreden bij het opslaan.');
    }
  };

  if (!isAuthenticated) {
    return <p>Je bent niet ingelogd.</p>;
  }

  return (
    <div className="create-note-generic">
      <h2>Nieuwe Notitie</h2>
      <form onSubmit={handleSubmit} className="note-form">
        <div className="form-group">
          <label htmlFor="studentSelect">Leerling</label>
          {loading ? (
            <p>Laden...</p>
          ) : (
            <select
              id="studentSelect"
              className="form-control"
              value={selectedStudentId}
              onChange={e => setSelectedStudentId(e.target.value)}
              required
            >
              <option value="">-- kies leerling --</option>
              {students.map(stu => (
                <option key={stu.student_id} value={stu.student_id}>
                  {stu.firstname} {stu.lastname}
                </option>
              ))}
            </select>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="noteDate">Datum</label>
          <input
            type="date"
            id="noteDate"
            className="form-control"
            value={noteDate}
            onChange={e => setNoteDate(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="content">Notitie</label>
          <textarea
            id="content"
            className="form-control"
            rows="8"
            value={content}
            onChange={e => setContent(e.target.value)}
            placeholder="Schrijf hier de notitie..."
            required
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <div className="form-actions">
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>
            Annuleren
          </button>
          <button type="submit" className="btn-submit">
            Opslaan
          </button>
        </div>
      </form>
    </div>
  );
}
